import { render, staticRenderFns } from "./KnowledgeBaseList.vue?vue&type=template&id=6ce47f92&scoped=true&"
import script from "./KnowledgeBaseList.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce47f92",
  null
  
)

export default component.exports